import initialState from './initialState';

export function siteRegionListHasErrored(
  state = initialState.siteRegionListHasErrored,
  action,
) {
  switch (action.type) {
    case 'SITE_REGION_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function siteRegionListIsLoading(
  state = initialState.siteRegionListIsLoading,
  action,
) {
  switch (action.type) {
    case 'SITE_REGION_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function siteRegionList(state = initialState.siteRegionList, action) {
  switch (action.type) {
    case 'SITE_REGION_LIST_FETCH_DATA_SUCCESS':
      return action.siteRegionList;
    default:
      return state;
  }
}

export function regionListHasErrored(
  state = initialState.regionListHasErrored,
  action,
) {
  switch (action.type) {
    case 'REGION_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function regionListIsLoading(
  state = initialState.regionListIsLoading,
  action,
) {
  switch (action.type) {
    case 'REGION_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function regionList(state = initialState.regionList, action) {
  switch (action.type) {
    case 'REGION_LIST_FETCH_DATA_SUCCESS':
      return action.regionList;
    default:
      return state;
  }
}

export function addSiteRegionHasErrored(
  state = initialState.addSiteRegionHasErrored,
  action,
) {
  switch (action.type) {
    case 'SITE_REGION_ADD_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function siteRegionAdding(
  state = initialState.siteRegionAdding,
  action,
) {
  switch (action.type) {
    case 'SITE_REGION_ADD_SAVING':
      return action.isLoading;
    default:
      return state;
  }
}
export function siteRegionAddSuccess(
  state = initialState.siteRegionAddSuccess,
  action,
) {
  switch (action.type) {
    case 'SITE_REGION_ADD_SUCCESS':
      return action.isSiteRegionSaveSuccess;
    default:
      return state;
  }
}

export function updateSiteRegionHasErrored(
  state = initialState.updateSiteRegionHasErrored,
  action,
) {
  switch (action.type) {
    case 'SITE_REGION_UPDATE_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function siteRegionUpdating(
  state = initialState.siteRegionUpdating,
  action,
) {
  switch (action.type) {
    case 'SITE_REGION_UPDATE_SAVING':
      return action.isLoading;
    default:
      return state;
  }
}
export function siteRegionUpdateSuccess(
  state = initialState.siteRegionUpdateSuccess,
  action,
) {
  switch (action.type) {
    case 'SITE_REGION_UPDATE_SUCCESS':
      return action.isSiteRegionSaveSuccess;
    default:
      return state;
  }
}

export function dealFunderListHasErrored(
  state = initialState.dealFunderListHasErrored,
  action,
) {
  switch (action.type) {
    case 'DEAL_FUNDER_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function dealFunderListIsLoading(
  state = initialState.dealFunderListIsLoading,
  action,
) {
  switch (action.type) {
    case 'DEAL_FUNDER_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function dealFunderList(state = initialState.dealFunderList, action) {
  switch (action.type) {
    case 'DEAL_FUNDER_LIST_FETCH_DATA_SUCCESS':
      return action.dealFunderList;
    default:
      return state;
  }
}
